module.exports = __webpack_public_path__ + "static/media/Template_22.0625cff8.png";